import { LoaderIcon } from "lucide-react";

import { cn } from "../lib/utils";

function Spinner({
  className,
  ...props
}: React.ComponentProps<"svg">): React.JSX.Element {
  return (
    <LoaderIcon
      data-slot="spinner"
      role="status"
      aria-label="Loading"
      className={cn("size-4 animate-spin", className)}
      {...props}
    />
  );
}

export { Spinner };
